import { API_URL } from '../../../app-config/constants';
import AdminLink from '../../../types/AdminLink';
import { get } from '../request';

const BASE = `${API_URL}/admin-links`;

getSettingsLinks.operation = 'READ';
export function getSettingsLinks() {
    return get<AdminLink[]>(`${BASE}/settings`);
}

getPromotionsLinks.operation = 'READ';
export function getPromotionsLinks() {
    return get<AdminLink[]>(`${BASE}/links`);
}

getIntegrationsLinks.operation = 'READ';
export function getIntegrationsLinks() {
    return get<AdminLink[]>(`${BASE}/integrations`);
}
